<template>
  <ion-page class="before-test">
    <img class="before-test_mask" src="@/assets/teacher_index/version5/test_mask.png" alt="" />
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div class="nav-icon"></div>
        <span>训前检测</span>
        <div style="display: inline-flex; align-items: center">
          <switch-font-size />
          <img
            class="nav-icon"
            :src="getBrandImageUrl('close_icon.png')"
            alt=""
            @click="onCloseModel"
          />
        </div>
      </div>
    </ion-header>
    <div class="word-box">
      <VideoHeight />
      <div id="before-test_outside_id" class="before-test_outside">
        <div class="statistic">{{ totalNum }}个单词</div>
        <div
          id="before-test_page_id"
          class="before-test_page"
          :class="{ 'scroll-disabled': !canScroll() }"
          @scroll="ionScroll($event)"
          @wheel="preventScroll"
          @touchmove="preventScroll"
        >
          <div class="word-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row justify-between align-center cursor-pointer"
              :class="{ 'choose-true': item.mastery === 1, 'choose-false': item.mastery === 8 }"
              @click="onShowParaphrase(index, item, $event)"
            >
              <span class="word-style flex-row align-center" style="width: calc(100% - 20%)">
                <span class="word-style">
                  <span class="gray-color font-small-size" style="flex-shrink: 0; font-size: 14px">
                    {{ index + 1 }}.&nbsp;
                  </span>
                  <span class="weight-600 switch-font-size-video"> {{ item.word }}</span>
                </span>
                <span v-show="item.showParaphrase == 2" class="cnword word-style gray-color ml-3">{{
                  item.paraphrase
                }}</span>
              </span>
              <div class="choose-icon flex-row align-center">
                <img
                  v-if="item.mastery === 0 || item.mastery === 1"
                  class="test-icon"
                  src="@/assets/teacher_index/version5/word_false.svg"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.mastery === 8"
                  class="test-icon"
                  src="@/assets/teacher_index/version5/checked_word_false.svg"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.mastery === 0 || item.mastery === 8"
                  class="test-icon ml-3"
                  src="@/assets/teacher_index/version5/word_ok.svg"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  v-if="item.mastery === 1"
                  class="test-icon ml-3"
                  src="@/assets/teacher_index/version5/checked_word_true.svg"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <!--                <img-->
                <!--                    class="test-icon ml-3"-->
                <!--                    :src="getBrandImageUrl('speed/not_play_icon.png')"-->
                <!--                    alt=""-->
                <!--                />-->
                <!--                <img-->
                <!--                    v-if="false"-->
                <!--                    class="test-icon ml-3"-->
                <!--                    :src="getBrandImageUrl('speed/playing_icon.png')"-->
                <!--                    alt=""-->
                <!--                />-->
              </div>
            </div>
            <ion-content>
              <ion-infinite-scroll
                id="infinite-scroll"
                threshold="100px"
                :disabled="isDisabled"
                @ionInfinite="loadData($event)"
              >
                <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
            </ion-content>
          </div>
        </div>
      </div>
    </div>
    <div class="before-test_bottom">
      <div class="before-test_bottom-content flex-row justify-between align-center">
        <span
          >已选择<span class="select-num">{{ selectNum }}</span
          >个单词</span
        >
        <div style="flex-shrink: 0">
          <ion-button class="btn golden_bg" shape="round" @click="onAutoChoice5Word"
            >选择5个
          </ion-button>
          <ion-button class="btn golden_bg" shape="round" @click="onAutoChoice"
            >选择45个
          </ion-button>
          <ion-button class="btn green_bg ml-2" shape="round" @click="onSubmit"
            >开始识记
          </ion-button>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import {
  IonButton,
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonPage,
  modalController,
} from "@ionic/vue"

import { checkmarkCircle, closeCircle, library } from "ionicons/icons"
import { openMsgToast } from "@/views/AIGenerate/openModal"
import { getBrandImageUrl } from "@/js/brandImages"
import { useDebounceFn, useScroll } from "@vueuse/core"
import { debounce } from "lodash"
import checkOkWord from "@/assets/teacher_index/version5/checked_word_false.svg"
import checkFalseWord from "@/assets/teacher_index/version5/checked_word_true.svg"
import mqttServer from "@/js/mqtt"
import pagesQueue from "@/js/pagesQueue"
import VideoHeight from "@/views/liveVideo/components/videoHeight.vue"
import { useStorage } from "@vueuse/core"
import SwitchFontSize from "@/views/liveVideo/components/switchFontSize.vue"

export default {
  name: "SpeedBeforeTest",
  components: {
    IonHeader,
    IonPage,
    IonContent,
    IonButton,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    VideoHeight,
    SwitchFontSize,
  },
  props: ["studentId", "classType"],
  setup() {
    // 获取会话存储中学生和老师单词列表高度
    const studentOffsetHeight = useStorage("studentOffsetHeight", "", sessionStorage)
    const teacherOffsetHeight = useStorage("teacherOffsetHeight", "", sessionStorage)
    // 获取会话存储中学生和老师单词列表宽度
    const studentOffsetWidth = useStorage("studentOffsetWidth", "", sessionStorage)
    const teacherOffsetWidth = useStorage("teacherOffsetWidth", "", sessionStorage)
    return {
      closeCircle,
      checkmarkCircle,
      library,
      studentOffsetHeight,
      teacherOffsetHeight,
      studentOffsetWidth,
      teacherOffsetWidth,
    }
  },

  data() {
    return {
      isDisabled: false,
      dataList: [],
      selectYesIndex: [], // 巡查官使用该数组确保展示同步
      selectNotIndex: [], // 巡查官使用该数组确保展示同步
      currentPage: 1,
      pageSize: 50,
      selectNum: 0,
      alreadyNnow: 0, //已经掌握
      courseId: undefined,
      courseName: undefined,
      selectAll: false, //全部选择
      submitting: false, //控制重复提交
      canScrollPermission: true, // 添加响应式的滚动权限状态
      instructData: {
        project: "lxll",
        page: "teachIndex",
        pageModle: true,
        module: "BeforeTest",
        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      notHaveNewWords: undefined,
      scrollQueryFn: null,
      totalNum: 0,
      debouncedScrollHandler: null, // 防抖滚动处理函数
    }
  },
  watch: {
    // 监听会话存储中老师通过即构通讯获取的学生单词列表高度，并设置老师单词列表高度
    studentOffsetHeight(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("before-test_outside_id")
      if (newVal > this.teacherOffsetHeight) {
        dom.style.height = this.teacherOffsetHeight + "px"
      } else {
        dom.style.height = newVal + "px"
      }
    },
    // 监听会话存储中学生通过即构通讯获取的老师单词列表高度，并设置学生单词列表高度
    teacherOffsetHeight(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("before-test_outside_id")
      if (newVal > this.studentOffsetHeight) {
        dom.style.height = this.studentOffsetHeight + "px"
      } else {
        dom.style.height = newVal + "px"
      }
    },
    // 监听会话存储中学生通过即构通讯获取的老师单词列表宽度，并设置学生单词列表宽度
    teacherOffsetWidth(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("before-test_outside_id")
      if (newVal > this.studentOffsetWidth) {
        dom.style.width = this.studentOffsetWidth + "px"
      } else {
        dom.style.width = newVal + "px"
      }
    },
    // 监听会话存储中老师通过即构通讯获取的学生单词列表宽度，并设置老师单词列表宽度
    studentOffsetWidth(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("before-test_outside_id")
      if (newVal > this.teacherOffsetWidth) {
        dom.style.width = this.teacherOffsetWidth + "px"
      } else {
        dom.style.width = newVal + "px"
      }
    },
  },

  mounted() {
    sessionStorage.removeItem("isManual")
    this.userinfo = this.store.getUser()
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)

    // 初始化滚动权限状态
    this.updateScrollPermission()

    // 添加权限变化监听器
    mqttServer.addPermissionListener(this.updateScrollPermission)
    // this.getCurrentLibrary();
    this.handleAlert().then((value) => {
      setTimeout(() => {
        value.dismiss("NEXT", "", "PageDialog")
      }, 2000)
    })
    // this.alert('认识的词点 <b>✓</b>,<br>不熟悉的点 <b>×</b>。');

    this.scrollQueryFn = useDebounceFn(() => {
      this.getCurrentLibrary()
    }, 500)

    // 初始化防抖滚动处理函数，整合scrollEvent逻辑确保同步执行
    this.debouncedScrollHandler = debounce((e) => {
      // 执行scrollEvent的逻辑：检测滚动方向，触发数据加载
      const { directions } = useScroll(e.target)
      if (directions.bottom) {
        this.scrollQueryFn()
      }

      // 只有有滚动权限的用户才能发送滚动消息
      if (this.canScroll()) {
        mqttServer.pushMsg(this.instructData, {
          params: [
            JSON.parse(JSON.stringify(e.target.scrollTop)),
            JSON.parse(JSON.stringify(directions.bottom)),
          ],
          fn: "handleScroll",
          msgType: "function",
          udp: true,
        })
      }
    }, 500)

    if (this.dataList.length == 0) {
      this.getCurrentLibrary()
    } else {
      setTimeout(() => {
        sessionStorage.setItem("pageFlag", "true")
      })
    }
    // 巡查官不执行后续代码
    if (this.userinfo.isAdmin) return
    setTimeout(() => {
      // 等待1秒iframe浏览器渲染完成，获取单词列表高度，并抛出到父级窗口
      let dom = document.getElementById("before-test_outside_id")
      window.parent.postMessage(
        {
          offsetHeight: dom.offsetHeight,
          offsetWidth: dom.offsetWidth,
          userType: this.userinfo.userType,
        },
        "*"
      )
      // 设置会话存储中学生和老师单词列表高度
      if (this.userinfo.userType == 1) {
        this.studentOffsetHeight = dom.offsetHeight
        this.studentOffsetWidth = dom.offsetWidth
      } else {
        this.teacherOffsetHeight = dom.offsetHeight
        this.teacherOffsetWidth = dom.offsetWidth
      }
    }, 1000)
  },

  beforeUnmount() {
    // 清理防抖函数
    if (this.debouncedScrollHandler) {
      this.debouncedScrollHandler.cancel()
    }
    // 移除权限变化监听器
    mqttServer.removePermissionListener(this.updateScrollPermission)
  },

  methods: {
    // 检查当前用户是否有发送权限（即是否有滚动权限）
    canScroll() {
      const appointment = this.store.getAppointment()
      // 如果是巡查官，总是可以滚动,或者不是视频课，也能滚动
      if (this.userinfo.isAdmin || appointment.videoFlag != 1) {
        return true
      }
      // 使用响应式的权限状态
      return this.canScrollPermission
    },

    // 更新滚动权限状态
    updateScrollPermission() {
      this.canScrollPermission = mqttServer.getCanSend()
    },

    // 阻止滚动事件
    preventScroll(e) {
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },

    // 滚动事件监听
    ionScroll(e) {
      // 检查是否有滚动权限
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }

      // 使用防抖函数统一处理滚动事件和信令发送
      this.debouncedScrollHandler(e)
    },

    //处理滚动事件
    handleScroll(e, bottom) {
      if (bottom) {
        this.scrollQueryFn()
      }
      let dom = document.getElementById("before-test_page_id")
      // let domHeight = document.getElementById('scroll-wrap-article').clientHeight
      // let scrollHeight = e * domHeight
      dom.scrollTop = e
    },
    // 消息处理
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },

    // 打开提示对话框
    async handleAlert() {
      return this.alert(
        `<div style="line-height: 30px;">认识的词选 <img class="vertical-middle" style="width: 20px;" src="${checkOkWord}" />，\n不熟悉的选 <img class="vertical-middle" style="width: 20px;"src="${checkFalseWord}" />。</div>`,
        "",
        "",
        true,
        false
      )
    },
    getBrandImageUrl,
    scrollEvent(e) {
      const { directions } = useScroll(e.target)
      if (directions.bottom) {
        this.scrollQueryFn()
      }
    },
    //处理滚动事件
    handleScrollEvent(e) {
      let dom = document.getElementById("before-test_page")
      dom.scrollTop = e
    },
    routerBack() {
      modalController.dismiss()
    },

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.dataList = []
      this.currentPage = 1
      this.getCurrentLibrary(RefreshAnimationEvent)
    },

    //发音异步
    onShowParaphraseSync(index, item) {
      this.playSoundTemp(item)
      // for (let i = 0; i < this.dataList.length; i++) {
      //   if (index == i) {
      //     if (this.dataList[i].showParaphrase < 2) {
      //       this.dataList[i].showParaphrase++
      //     } else {
      //       this.dataList[i].showParaphrase = 0
      //     }
      //   } else {
      //     this.dataList[i].showParaphrase = 0
      //   }
      // }
    },

    // 关闭学前检测
    onCloseModel() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onCloseModelSync",
          msgType: "function",
        })
        .then(() => {
          this.onCloseModelSync()
        })
    },
    onCloseModelSync() {
      pagesQueue.queuePagePop()
      modalController.dismiss({ status: "BEFORE_TEST" })
    },

    onShowParaphrase(index, item) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [index, item],
          fn: "onShowParaphraseSync",
          msgType: "function",
        })
        .then(() => {
          this.onShowParaphraseSync(index, item)
        })
    },

    countSelectNum() {
      this.selectNum = 0
      this.alreadyNnow = 0
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].mastery == 1) {
          this.selectNum++
        } else if (this.dataList[i].mastery == 8) {
          this.alreadyNnow++
        }
      }
    },

    //学新
    async openSignSync() {
      sessionStorage.setItem("pageFlag", "false")

      pagesQueue.queuePagePush({
        page: "Sign",
        params: { studentId: this.studentId, step: 1 },
      })

      // const modal = await modalController.create({
      //   component: Sign,
      //   componentProps: { studentId: this.studentId, step: 1 },
      //   cssClass: "modal_controller_class",
      // })
      // await modal.present()
      // const { data } = await modal.onDidDismiss()
      // console.log(data)
      // if (data) {
      //   await modalController.dismiss({ ...data })
      // }
    },

    //学新
    async openSign() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "openSignSync",
          msgType: "function",
        })
        .then(async () => {
          this.openSignSync()
        })
    },
    async listenModalDismiss() {
      await this.signModal.onDidDismiss()
      this.onCloseModelSync()
    },

    //提交单词列表
    onSubmit() {
      //控制重复提交
      if (this.submitting) {
        return
      }

      this.countSelectNum()
      if (this.selectNum + this.alreadyNnow == 0) {
        openMsgToast("请选择单词")
        // this.alert();
        return
      }

      //创建表单参数对象
      const param = { studentId: this.studentId }

      //数据提交地址，根据是否陪练体验而不同
      let url = "/vocabulary/beginNewClass"

      //如果用户就是自己，则判断为陪练自己在体验教学流程
      if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
        url = "/vocabulary/beginTrailClass"
        param.courseId = this.store.getTrialCourseId()
      }

      //陪练给用户上课
      else {
        const appointment = this.store.getAppointment()
        param.aptmId = appointment.aptmId
        param.courseId = appointment.courseId
        param.courseName = appointment.courseName
      }

      //创建已经选择的单词列表
      const selectedItem1 = []
      const selectedItem2 = []

      if (this.dataList && this.dataList.length > 0) {
        // 打勾的单词mastery=8，打叉的mastery=1
        //此处找出所有被打了X标记的单词
        this.dataList.forEach((item) => {
          if (item.mastery > 0) {
            let obj = {
              vocabularyId: item.vocabularyId,
              studentId: this.studentId,
              word: item.word,
              courseId: item.courseId,
              mastery: item.mastery,
              paraphrase: item.paraphrase,
              pronunciation: item.pronunciation,
            }
            selectedItem1.push(obj)
            if (item.mastery == 1) {
              selectedItem2.push(obj)
            }
          }
        })
      }

      //提交所有打了标记的单词
      param.list = selectedItem1

      //如果是陪练教学流程，则只需要把打叉的单词提交
      if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
        param.list = selectedItem2
      }
      //锁定提交状态，避免重复提交
      this.submitting = true

      this.ajax.post(url, param).then((res) => {
        //释放提交状态
        this.submitting = false
        if (res.data.success) {
          //本地只存储打了叉的单词
          param.list = selectedItem2
          const appointment = this.store.getAppointment()
          if (appointment.videoFlag == 1) {
            mqttServer
              .pushMsg(this.instructData, {
                params: [res, this.selectYesIndex, this.selectNotIndex],
                fn: "onSubmitSync",
                msgType: "function",
              })
              .then(() => {
                this.onSubmitSync(res)
              })
          } else {
            this.onSubmitSync(res)
          }
        } else {
          modalController.dismiss({ status: "BEFORE_TEST" })
        }
      })
    },

    async onSubmitSync(res, selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          this.dataList[selectYesIndex[i]].mastery = 8
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          this.dataList[selectNotIndex[i]].mastery = 1
        }
        this.countSelectNum()
      }
      //本地只存储打了叉的单词
      if (res.data.trialId) {
        this.store.setTrialId(res.data.trialId)
      }
      //如果选择了单词，则打开单词识记界面
      if (this.selectNum > 0) {
        if (this.userinfo.userType == 1) {
          this.openSignSync()
        }
        if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
          this.openSignSync()
        } else {
          this.createForgetSync()
        }
      } else {
        this.onCloseModelSync()
      }
    },

    async createForgetSync() {
      const appointment = this.store.getAppointment()
      const params = {
        aptmId: appointment.aptmId,
        startTime: appointment.beginTime,
      }
      return this.ajax.post("/forget/generateForget", params).then(() => {
        this.openSignSync()
      })
    },

    async createForget() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [],
          fn: "createForgetSync",
          msgType: "function",
        })
        .then(() => {
          this.createForgetSync()
        })
    },

    onTempSelectAllYesSync() {
      this.selectAll = true
      this.dataList.forEach(function (item) {
        item.mastery = 8
        item.yesColor = "success"
        item.notColor = "gainsboro"
        item.showParaphrase = 0
      })
      this.countSelectNum()
    },

    onTempSelectAllYes() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [],
          fn: "onTempSelectAllYesSync",
          msgType: "function",
        })
        .then(() => {
          this.onTempSelectAllYesSync()
        })
    },

    //自动选择 5个
    onAutoChoice5WordSync(selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          this.dataList[selectYesIndex[i]].mastery = 8
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          this.dataList[selectNotIndex[i]].mastery = 1
        }
      }
      this.selectAll = true
      let selectedItem1 = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].mastery == 1) {
          selectedItem1.push(this.dataList[i])
        }
      }

      if (selectedItem1.length >= 45) {
        selectedItem1 = []
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].mastery = 0
        }
      }

      let num = 0

      for (let i = 0; i < this.dataList.length; i++) {
        if (num >= 5 || selectedItem1.length >= 45) {
          break
        }

        if (this.dataList[i].mastery == 0) {
          this.dataList[i].mastery = 1
          selectedItem1.push(this.dataList[i])
          num++
          this.selectNotIndex.push(i)
        }
      }
      this.selectNotIndex = [...new Set(this.selectNotIndex)]
      this.countSelectNum()
    },

    //自动选择 5个
    onAutoChoice5Word() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.selectYesIndex, this.selectNotIndex],
          fn: "onAutoChoice5WordSync",
          msgType: "function",
        })
        .then(() => {
          this.onAutoChoice5WordSync()
        })
    },

    //自动选择
    onAutoChoiceSync(selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          this.dataList[selectYesIndex[i]].mastery = 8
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          this.dataList[selectNotIndex[i]].mastery = 1
        }
      }
      this.selectAll = true
      const selectedItem1 = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].mastery == 1) {
          selectedItem1.push(this.dataList[i])
        }
      }

      for (let i = 0; i < this.dataList.length; i++) {
        if (selectedItem1.length < 45) {
          if (this.dataList[i].mastery == 0) {
            this.dataList[i].mastery = 1
            this.dataList[i].yesColor = "gainsboro"
            this.dataList[i].notColor = "danger"
            selectedItem1.push(this.dataList[i])
          }
        } else {
          break
        }
      }
      this.countSelectNum()
    },

    //自动选择
    onAutoChoice() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.selectYesIndex, this.selectNotIndex],
          fn: "onAutoChoiceSync",
          msgType: "function",
        })
        .then(() => {
          this.onAutoChoiceSync()
        })
    },

    // item.mastery = 0 未选择 1 错误 8 正确
    //全部取消选择
    onCancelChoiceAsync() {
      this.selectAll = false
      this.dataList.forEach(function (item) {
        item.mastery = 0
        item.showParaphrase = 0
      })
      this.countSelectNum()
    },

    // item.mastery = 0 未选择 1 错误 8 正确
    //全部取消选择
    onCancelChoice() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onCancelChoiceSync",
          msgType: "function",
        })
        .then(() => {
          this.onCancelChoiceSync()
        })
    },

    onClickYesSync(item, selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          if (this.dataList[selectYesIndex[i]].mastery != 8) {
            this.dataList[selectYesIndex[i]].mastery = 8
          }
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          if (this.dataList[selectNotIndex[i]].mastery != 1) {
            this.dataList[selectNotIndex[i]].mastery = 1
          }
        }
        // 合并selectYesIndex和selectNotIndex，在dataList中找到索引不等于合并后的索引的单词，把mastery设置为0
        const allIndex = [...selectYesIndex, ...selectNotIndex]
        for (let i = 0; i < this.dataList.length; i++) {
          if (!allIndex.includes(i)) {
            this.dataList[i].mastery = 0
          }
        }
        this.countSelectNum()
      } else {
        let currentItem = this.dataList.find((i) => i.vocabularyId === item.vocabularyId)
        if (currentItem.mastery == 8) {
          currentItem.mastery = 0
        } else {
          currentItem.mastery = 8
        }
        currentItem.showParaphrase = currentItem.mastery === 8 ? 2 : 0
        this.countSelectNum()
      }
    },

    onClickYes(item) {
      // 巡查官-找到当前单词在dataList中的索引，并添加到selectYesIndex中
      const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
      const yesInd = this.selectYesIndex.findIndex((i) => i == ind)
      if (yesInd == -1) {
        this.selectYesIndex.push(ind)
        this.selectYesIndex = [...new Set(this.selectYesIndex)]
      } else {
        this.selectYesIndex.splice(yesInd, 1)
      }
      // 巡查官-在selectNotIndex中查找ind，如果存在，则删除
      const notInd = this.selectNotIndex.findIndex((i) => i == ind)
      if (notInd != -1) {
        this.selectNotIndex.splice(notInd, 1)
      }

      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [item, this.selectYesIndex, this.selectNotIndex],
            fn: "onClickYesSync",
            msgType: "function",
          })
          .then(() => {
            this.onClickYesSync(item)
          })
      } catch (error) {
        // 如果出现错误，则把前面selectYesIndex的push的ind删除
        this.selectYesIndex.splice(this.selectYesIndex.length - 1, 1)
        // 如果出现错误并且selectNotIndex存在，则把ind重新添加到selectNotIndex中
        if (this.selectNotIndex.length > 0) {
          this.selectNotIndex.push(ind)
          this.selectNotIndex = [...new Set(this.selectNotIndex)]
        }
      }
    },

    onClickNotSync(item, selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectNotIndex.length; i++) {
          if (this.dataList[selectNotIndex[i]].mastery != 1) {
            this.dataList[selectNotIndex[i]].mastery = 1
          }
        }
        for (let i = 0; i < selectYesIndex.length; i++) {
          if (this.dataList[selectYesIndex[i]].mastery != 8) {
            this.dataList[selectYesIndex[i]].mastery = 8
          }
        }
        // 合并selectYesIndex和selectNotIndex，在dataList中找到索引不等于合并后的索引的单词，把mastery设置为0
        const allIndex = [...selectYesIndex, ...selectNotIndex]
        for (let i = 0; i < this.dataList.length; i++) {
          if (!allIndex.includes(i)) {
            this.dataList[i].mastery = 0
          }
        }
        this.countSelectNum()
      } else {
        let currentItem = this.dataList.find((i) => i.vocabularyId === item.vocabularyId)

        if (currentItem.mastery == 1) {
          currentItem.mastery = 0
        } else {
          if (this.selectNum >= 45) {
            this.alert("不能再选啦~~")
            return
          }

          currentItem.mastery = 1
        }

        currentItem.showParaphrase = currentItem.mastery === 1 ? 2 : 0
        this.countSelectNum()
      }
    },

    onClickNot(item) {
      const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
      const notInd = this.selectNotIndex.findIndex((i) => i == ind)
      if (notInd == -1) {
        this.selectNotIndex.push(ind)
        this.selectNotIndex = [...new Set(this.selectNotIndex)]
      } else {
        this.selectNotIndex.splice(notInd, 1)
      }
      // 在selectYesIndex中查找ind，如果存在，则删除
      const yesInd = this.selectYesIndex.findIndex((i) => i == ind)
      if (yesInd != -1) {
        this.selectYesIndex.splice(yesInd, 1)
      }
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [item, this.selectYesIndex, this.selectNotIndex],
            fn: "onClickNotSync",
            msgType: "function",
          })
          .then(() => {
            this.onClickNotSync(item)
          })
      } catch (error) {
        // 如果出现错误，则把前面selectNotIndex的push的ind删除
        this.selectNotIndex.splice(this.selectNotIndex.length - 1, 1)
        // 如果出现错误并且yesInd存在，则把ind重新添加到selectYesIndex中
        if (yesInd != -1) {
          this.selectYesIndex.push(ind)
          this.selectYesIndex = [...new Set(this.selectYesIndex)]
        }
      }
    },

    queryVocabularySync(res, ev) {
      const page = res.data.page
      this.totalNum = res.data.page.total
      if (page.list && page.list.length > 0) {
        for (let i = 0; i < page.list.length; i++) {
          page.list[i].mastery = 0
          page.list[i].showParaphrase = 0
          this.dataList.push(page.list[i])
        }
      }

      //本课程无新单词可学
      else {
        this.notHaveNewWords = "本训练已完成，请切换其它训练继续训练！"
      }

      if (ev) {
        ev.target.complete()
      }
      this.currentPage++
      sessionStorage.setItem("pageFlag", "true")
    },

    queryVocabulary(ev) {
      this.notHaveNewWords = undefined
      const params = {
        courseId: this.courseId,
        studentId: this.studentId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.ajax.post("/vocabulary/queryNotInPersonal", params).then((res) => {
        this.queryVocabularySync(res, ev)
      })
    },

    loadData(ev) {
      this.queryVocabulary(ev)
      ev.target.complete()
    },

    getCurrentLibrary(ev) {
      this.ajax.get("/course/getCurrentCourse?studentId=" + this.studentId).then((res) => {
        if (res.data.success) {
          this.courseName = res.data.data.courseName
          this.courseId = res.data.data.courseId
          this.queryVocabulary(ev)
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.word-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.before-test {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 0 20%;
  user-select: none;
  -webkit-user-select: none;
  background: #f2f3f6;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &_mask {
    position: absolute;
    right: 0;
    top: 0;
    width: 12rem;
    z-index: 2;
  }

  &_outside {
    position: relative;
    z-index: 3;
    margin: 0 auto;
    width: 95%;
    height: 80%;
    background: #ffffff;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;

    .statistic {
      color: var(--font-grey-color);
      height: 40px;
      line-height: 40px;
      padding-left: 1rem;
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    /* 滚动条的颜色 */
    border-radius: 10px;
    /* 滚动条的角度样式 */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 鼠标悬停时的颜色 */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 滚动条轨道的颜色，可以理解为背景 */
    border-radius: 10px;
    /* 滚动条轨道的圆角 */
  }

  &_page {
    width: 100%;
    // height: 70%;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }

    &.scroll-disabled {
      overflow: hidden;
      pointer-events: none;
    }

    .word-list {
      &_item {
        padding: 20px;
        border-bottom: 1px solid #eaeaea;

        .word-style {
          display: inline-block;
          font-size: 16px;
          word-break: break-all;
        }

        .choose-icon {
          width: 20%;
          flex-shrink: 0;
        }

        .ml-3 {
          margin-left: 10px;
        }
      }

      .item-checked {
        border: 1px solid var(--theme-color);
      }

      .choose-false {
        background: linear-gradient(0deg, rgba(16, 194, 139, 0.04), rgba(16, 194, 139, 0.04));
      }

      .choose-true {
        background: linear-gradient(0deg, rgba(255, 173, 0, 0.04), rgba(255, 173, 0, 0.04));
      }

      .test-icon {
        width: 24px;
      }
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8%;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);
    z-index: 4;

    &-content {
      flex-shrink: 0;
      height: 60%;
      padding: 3vh 3vw 0;
      color: #9a9b9c;

      .select-num {
        color: #ffad00;
        font-size: 1.2rem;
        font-weight: 600;
      }
    }
  }
}

::v-deep(.btn) {
  width: 5rem;
}
</style>
